import { Directive } from '@angular/core';

@Directive({
  selector: '[algSelectTrigger]',
})
export class SelectTriggerDirective {}
